import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as actions from 'react/api/actions/stopDetailsPopup';
import ButtonWithIcon from 'react/components/ButtonWithIcon';
import { 
  geocodeIcon,
  geocodeIconActive
} from 'react/utils/stopDetailsPopupBase64Icons.js';

class GeocodeButton extends Component {
  
  toggleGeocode = () => {
    const { 
      routeId, stopId, geocodeIsEnabled, 
      enableGeocodeAction, cancelGeocodeAction 
    } = this.props;
    if (geocodeIsEnabled) {
      cancelGeocodeAction(routeId, stopId);
    } else {
      enableGeocodeAction(routeId, stopId);
    }
  }

  componentDidMount = () => {
    const { 
      routeId, stopId, geocodeIsEnabled, enableGeocodeAction 
    } = this.props;
    if (geocodeIsEnabled) {
      enableGeocodeAction(routeId, stopId);
    }
  }
  
  render() {
    const { geocodeIsEnabled, ...others } = this.props; 
    return (
      <ButtonWithIcon
      label={Monet.I18n.getResourcesByKey('routeDetails.stopDetailsPopup.geocodeStop')} 
      iconUrl={geocodeIcon}
      activeIconUrl={geocodeIconActive}
      isActive={geocodeIsEnabled}
      onClick={this.toggleGeocode}
      {...others}/>
    );
  }
}

GeocodeButton.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  geocodeIsEnabled: PropTypes.bool.isRequired,
  enableGeocodeAction: PropTypes.func.isRequired,
  cancelGeocodeAction: PropTypes.func.isRequired
}

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({ 
  geocodeIsEnabled: stopDetailsPopup.getIn(['actionButtons', String(routeId), String(stopId), 'geocodeIsEnabled'], false)
});

const mapDispatchToProps = (dispatch) => ({
  enableGeocodeAction: bindActionCreators(actions.enableGeocode, dispatch),
  cancelGeocodeAction: bindActionCreators(actions.cancelGeocode, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(GeocodeButton);

